import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { merge } from 'lodash-es';
import { ApiResponse } from '../../../../classes/api-response';
import { UsersService } from '../../../../services/users.service';
import { SnackService } from '../../../../services/snack.service';
import { Logistic } from "../../../../model/logistic";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'aw-logistic-form',
  templateUrl: './logistic-form.component.html',
  styleUrls: ['./logistic-form.component.scss']
})
export class LogisticFormComponent implements OnInit {

  userForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  generalError?: ApiResponse;
  previousUrl: string = '';


  constructor(
    private userService: UsersService,
    private snackService: SnackService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (route.snapshot.url[0])
      this.previousUrl = route.snapshot.url[0].path;
    this.userForm = new UntypedFormGroup(
      {
        email: new UntypedFormControl(
          '',
          [
            Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"),
            Validators.required
          ]
        ),
        firstName: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.pattern('^(?!\\.)(?!.*\\.$)(?!.*?\\.\\.)(?![\\s.]+$)[a-zA-Z\\s.]*$')

          ]
        ),
        lastName: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.pattern('^(?!\\.)(?!.*\\.$)(?!.*?\\.\\.)(?![\\s.]+$)[a-zA-Z\\s.]*$')
          ]
        ),
        phone: new UntypedFormControl(
          '',
          [
            Validators.pattern('[- +()0-9]+'),
            Validators.required
          ]
        )
      },
    );



  }
  _logistic = new Logistic();

  @Input() set logistic(value: Logistic) {
    this._logistic = merge(new Logistic(), value);
    this.userForm.patchValue(this._logistic);
    if (value.id) {
      this.userForm.controls.email.disable();
    }
  }

  ngOnInit(): void {

  }

  saveUser(): void {

    this.saving = true;


    const newUser = merge(new Logistic(), this._logistic, this.userForm.value);

    this.generalError = undefined;

    if (this._logistic.id) {
      this.userService.updateLogistic(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.logistic = newUser;
            this.snackService.success('Logistic updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {
      this.userService.createLogistic(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.logistic = newUser;
            this.snackService.success('Logistic created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

  onCancel():void {

    if(this.previousUrl === 'edit')
      this.router.navigateByUrl("/reserved/profile")
    this.logistic = this._logistic;
    this.canceled.emit();

  }




}
